export default __webpack_public_path__ + "static/media/emptyPlaceholder.174be017.png";